/**
 * This file is part of Iconika.
 *
 * Iconika is free software: you can redistribute it and/or modify it
 * under the terms of the GNU General Public License as published by
 * the Free Software Foundation, either version 2 of the License, or
 * any later version.
 *
 * Iconika is distributed in the hope that it will be useful, but
 * WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with Iconika.  If not, see <https://www.gnu.org/licenses/>.
 */
{
	const closeLink = document.querySelector('#whatsapp-consent a[href="#"]');
	if (closeLink) {
		closeLink.addEventListener('click', function(e) {
			e.preventDefault();
			window.history.back();
		}, false);
		
	}
}
